import { CalendarEntityType } from '../../../../stores';
import { ReorderConfirmHandlerResponse, useColumnEntityReorderStore } from '../../providers';
import { ColumnEntity } from '../../types';

export type UseAddNewOrderToQueueProps = {
  locationId: string;
  calendarEntityType: CalendarEntityType;
  setList: (list: ColumnEntity[]) => void;
  resetList: () => void;
};

export const useAddNewOrderToQueue = ({
  locationId,
  calendarEntityType,
  setList,
  resetList,
}: UseAddNewOrderToQueueProps) => {
  const { setIsReordering, addToColumnReorderHandlers, removeColumnReorderHandler } = useColumnEntityReorderStore([
    'setIsReordering',
    'addToColumnReorderHandlers',
    'removeColumnReorderHandler',
  ]);

  //onConfirmHandlerCreator is used to create a confirm handler to be added to the queue
  const onConfirmHandlerCreator = (newOrderIdMap: Record<string, number>) => () => {
    setIsReordering(true);

    // remove this handler from the queue
    removeColumnReorderHandler(locationId);

    // return the new order to the preference store
    return [calendarEntityType, locationId, newOrderIdMap] satisfies ReorderConfirmHandlerResponse;
  };

  const onCancelHandlerCreator = () => () => {
    resetList();
    // Clean up the confirm handler after cancelling
    removeColumnReorderHandler(locationId);
  };

  const addNewOrderToQueue = (newOrderIdMap: Record<string, number>, newList: ColumnEntity[]) => {
    setList(newList);
    // Register the confirm handler to be called later
    addToColumnReorderHandlers(locationId, {
      confirm: onConfirmHandlerCreator(newOrderIdMap),
      cancel: onCancelHandlerCreator(),
    });
  };

  return { addNewOrderToQueue };
};
